<template>
    <div>
        <el-col :span="24" class="text-md-left" style="margin-top:10px;">
                <el-alert
                    style="margin-bottom:10px;"
                    title="Courier Account"
                    type="warning"
                    :closable="false"
                    description="ระบบใช้งานขนส่ง สามารถเพิ่มหรือแก้ไขได้ จากเมนู Courier"
                    show-icon>
                </el-alert>
            </el-col>
            <el-col :span="24" class="text-xs-left">
                        <el-row type="flex" align="middle">
                            <el-col class="text-md-left" :span="12" style="margin-bottom:5px;">
                                <el-button type="primary" @click="innerVisible = true">เพิ่มขนส่ง</el-button>
                            </el-col>
                        </el-row>
                        <el-dialog
                            lock-scroll
                            width="50%"
                            top="2vh"
                            :close-on-click-escape="false"
                            :close-on-click-modal="false"
                            :visible.sync="innerVisible"
                            custom-class="dialogCourierList"
                            style="font-family: 'Prompt', sans-serif"
                            append-to-body>
                            <template slot="title">
                                <h2 style="margin:unset;text-align:left;">เพิ่มขนส่ง</h2>
                            </template>
                            <el-row>
                                <el-col class="text-md-left" :sm="24">
                                    <el-card shadow="never" style="padding-bottom:20px;">
                                        <el-row>
                                            <el-col class="text-md-left" :span="24">
                                                <el-form :inline="true" @submit.native.prevent="() => {}">
                                                    <el-form-item label="เลือกขนส่ง">
                                                        <el-select
                                                            v-model="selProvider"
                                                            @change="fetchCourierAccount"
                                                            placeholder="ผู้ให้บริการ">
                                                            <el-option
                                                                v-for="item in listProvider"
                                                                :key="item.courierProviderId"
                                                                :label="item.name"
                                                                :value="item.courierProviderId">
                                                            </el-option>
                                                        </el-select>
                                                    </el-form-item>
                                                </el-form>
                                            </el-col>

                                        </el-row>
                                        <el-row>
                                            <el-col class="text-md-left">
                                                <el-table
                                                    :data="courierAccList"
                                                    stripe
                                                    :default-sort = "{prop: 'courierAccountId', order: 'descending'}"
                                                    :header-cell-style="{'background-color': 'black', 'color': 'white'}"
                                                    v-loading="loadingAccList"
                                                    style="width: 100%">
                                                    <el-table-column label="ชื่อผู้ให้บริการ" >
                                                        <div class="text-md-left" slot-scope="scope">
                                                            {{ scope.row.name }}
                                                        </div>
                                                    </el-table-column>
                                                    <el-table-column label="Shipper ID" >
                                                        <div class="text-md-left" slot-scope="scope">
                                                            {{ scope.row.apiData ? scope.row.apiData.shipperCode : '-' }}
                                                        </div>
                                                    </el-table-column>
                                                    <el-table-column label="ผู้ใช้งาน" >
                                                        <div class="text-md-left" slot-scope="scope">
                                                            <!-- {{ scope.row.apiData.username }} -->
                                                            {{ scope.row.apiData ? scope.row.apiData.username : '-' }}
                                                        </div>
                                                    </el-table-column>
                                                    <el-table-column label="รหัสผ่าน">
                                                        <div slot-scope="scope">
                                                            <div v-if="scope.row.apiData">
                                                                <a
                                                                    @click.stop="showPassword(scope.$index)"
                                                                    style="color:#409EFF; text-decoration: none;"
                                                                    v-if="!passwordShowed[scope.$index]">
                                                                    show
                                                                </a>

                                                                <span v-else>
                                                                    {{scope.row.apiData.password}}
                                                                    (
                                                                <a
                                                                    @click.stop="hidePassword(scope.$index)"
                                                                    style="color:#409EFF; text-decoration: none;">
                                                                    hide
                                                                </a>)
                                                                </span>
                                                            </div>
                                                            <div v-else>
                                                                -
                                                            </div>
                                                        </div>
                                                    </el-table-column>
                                                    <el-table-column label="จัดการ" >
                                                        <div class="text-md-left" slot-scope="scope">
                                                                <el-button type="primary" @click="handleAddCourierAccount(scope.row)">เพิ่ม</el-button>
                                                        </div>
                                                    </el-table-column>
                                                </el-table>
                                            </el-col>
                                        </el-row>
                                    </el-card>
                                </el-col>
                            </el-row>
                            <span slot="footer" class="dialog-footer">
                                <el-button @click="innerVisible = false" type="danger" plain>ยกเลิก</el-button>
                                <!-- <el-button type="primary" @click="submitEditUser('userForm')">บันทึก</el-button> -->
                            </span>
                        </el-dialog>
                        <el-table
                            :data="courierInfo.courierAccounts"
                            v-loading="loadingTable"
                            :header-cell-style="{'background-color': 'black', 'color': 'white', 'text-align': 'center'}"
                            style="width: 100%">
                            <el-table-column prop="name"  label="ขนส่ง" width="120"></el-table-column>
                            <el-table-column label="shipper Code" width="200">
                                <div class="text-md-left" slot-scope="scope">
                                    {{ scope.row.apiData.status ? scope.row.apiData.shipperCode : '-' }}
                                </div>
                            </el-table-column>
                            <el-table-column label="ผู้ใช้งาน" min-width="200">
                                <div class="text-md-left" slot-scope="scope">
                                    {{ scope.row.apiData.status ? scope.row.apiData.username : '-' }}
                                </div>
                            </el-table-column>
                            <el-table-column label="รหัสผ่าน" width="120">
                                <div class="text-md-left" slot-scope="scope">
                                    {{ scope.row.apiData.status ? scope.row.apiData.password : '-' }}
                                </div>
                            </el-table-column>
                            <el-table-column label="วัน" width="120">
                                <div class="text-md-left" slot-scope="scope">
                                    <!-- {{ scope.row.apiData.status ? scope.row.apiData.password : '-' }} -->
                                    <el-input v-model="scope.row.day" :disabled="scope.row.courierId !== 1 && scope.row.courierId !== 4 && scope.row.courierId !== 10"></el-input>
                                </div>
                            </el-table-column>
                            <el-table-column label="เวลาเริ่มต้น" width="180">
                                <div class="text-md-center" slot-scope="scope">
                                    <el-time-picker
                                        placeholder="เวลาเริ่มต้น"
                                        v-model="scope.row.timeStart"
                                        style="width: 80%;"
                                        format="HH:mm"
                                    >
                                    </el-time-picker>
                                </div>
                            </el-table-column>
                            <el-table-column label="เวลาสิ้นสุด" width="180">
                                <div class="text-md-center" slot-scope="scope">
                                    <el-time-picker
                                        placeholder="เวลาสิ้นสุด"
                                        v-model="scope.row.timeEnd"
                                        style="width: 80%;"
                                        format="HH:mm"
                                    >
                                    </el-time-picker>
                                </div>
                            </el-table-column>
                            <el-table-column label="จัดการ" width="200">
                                <div slot-scope="scope">
                                    <el-button type="danger" size="small" icon="el-icon-delete" @click="handleDeleteCourierAccount(scope.$index)"></el-button>
                                    <el-button type="info" :disabled="scope.$index===0" size="small" icon="el-icon-arrow-up" @click="handleUpCourierAccount(scope.$index)" ></el-button>
                                    <el-button type="info" :disabled="scope.$index === (courierInfo.courierAccounts.length -1)" size="small" icon="el-icon-arrow-down" @click="handleDownCourierAccount(scope.$index)"></el-button>
                                </div>
                            </el-table-column>
                        </el-table>
                    </el-col>
    </div>
</template>

<script>
import fgApi from '@/services/fillgoods'
export default {
    name: 'CustomerCourier',
    props: {
        detail: {
            type: Object
        },
        provinceArray: {
            type: Array,
            default: null
        },
        geoHierarchyData: {
            type: Object,
            default: null
        },
        seller: {
            type: Array
        },
        log: {
            type: Object,
            default: null
        },
        courierInfo: {
            type: Object,
            default: () => {
                return {
                    courierAccounts: []
                }
            }
        }

    },
    data () {
        return {
            flagEditMail: true,
            loadingTable: false,
            passwordShowed: [],
            innerVisible: false,
            listProvider: [],
            selProvider: null,
            loadingAccList: false,
            courierAccList: []
        }
    },
    watch: {
        'detail.dialog' (val) {
            if (val) {
                this.fetchCourierProvider(this.detail.data.userId)
            } else {
                this.flagEditMail = true
                this.courierInfo.courierAccounts = []
                this.detail.data = {}
            }
        },
        innerVisible (val) {
            if (val) {
                this.fetchListProvider()
            }
        }
    },
    created () {
        this.fetchCourierProvider(this.detail.data.userId)
    },
    methods: {
        async fetchCourierAccount () {
            this.loadingAccList = true
            let param = {
                courier_provider_id: this.selProvider
            }
            let res = await fgApi.courier.getCourierAccount(param)
            console.log(res)
            this.courierAccList = res.data.filter(e => e.deletedAt == null)
            this.passwordShowed = res.data.map(e => false)
            this.loadingAccList = false
        },
        handleAddCourierAccount (courierAccount) {
            let checkCour = this.courierInfo.courierAccounts.filter(e => (e.courierAccountId === courierAccount.courierAccountId))
            if (checkCour.length > 0) {
                this.selProvider = null
                this.courierAccList = []
                this.innerVisible = false
                this.$message({
                    type: 'info',
                    message: 'ข้อมูลซ้ำ'
                })
            } else {
                // courierId =2 /kerry ให้กำหนดวัน -1
                courierAccount = { ...courierAccount, day: courierAccount.courierId !== 1 && courierAccount.courierId !== 4 && courierAccount.courierId !== 10 ? parseInt('-1') : parseInt('2') }
                let status = false
                if (courierAccount.apiData !== null) {
                    status = true
                }
                let apiData = { ...courierAccount.apiData, status: status }
                courierAccount = { ...courierAccount, apiData }
                this.courierInfo.courierAccounts.push(courierAccount)
                this.selProvider = null
                this.courierAccList = []
                this.innerVisible = false
                this.$message({
                    type: 'success',
                    message: 'เพิ่มสำเร็จ'
                })
            }
        },
        async fetchListProvider () {
            let loading = this.$loading({
                target: '.dialogCourierList',
                text: 'กำลังบันทึก...'
            })
            try {
                let res = await fgApi.courier.getListProvider()
                this.listProvider = res.data
            } catch (error) {
                console.log(error)
            }

            loading.close()
        },
        handleDeleteCourierAccount (obj) {
            this.$confirm('ยืนยันการลบรายการ ?', 'แจ้งเตือน!', {
                confirmButtonText: 'OK',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                this.$message({
                    type: 'success',
                    message: 'ลบสำเร็จ'
                })
                this.courierInfo.courierAccounts.splice(obj, 1)
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: 'ยกเลิกการลบ'
                })
            })
        },
        showPassword (index) {
            this.$set(this.passwordShowed, index, true)
        },
        hidePassword (index) {
            this.$set(this.passwordShowed, index, false)
        },
        handleUpCourierAccount (index) {
            let temp = { ...this.courierInfo.courierAccounts[index] }
            this.$set(this.courierInfo.courierAccounts, index, { ...this.courierInfo.courierAccounts[index - 1] })
            this.$set(this.courierInfo.courierAccounts, index - 1, temp)
        },
        handleDownCourierAccount (index) {
            let temp = { ...this.courierInfo.courierAccounts[index] }
            this.$set(this.courierInfo.courierAccounts, index, { ...this.courierInfo.courierAccounts[index + 1] })
            this.$set(this.courierInfo.courierAccounts, index + 1, temp)
        },
        async fetchCourierProvider (userId) {
            this.courierInfo.courierAccounts = []
            this.loadingTable = true
            let param = {
                target_user_id: userId
            }
            let res = await fgApi.courier.getCourierByUserID(param)
            if (res.success) {
                // set param log
                this.log.payload.lhs.courier = { ...res.data }
                res.data.autoCourier.map((e) => {
                    let timeStart = e.hasOwnProperty('timeStart') ? new Date(2016, 9, 10, e.timeStart.split(':')[0], e.timeStart.split(':')[1]) : null
                    let timeEnd = e.hasOwnProperty('timeEnd') ? new Date(2016, 9, 10, e.timeEnd.split(':')[0], e.timeEnd.split(':')[1]) : null
                    let data = {
                        day: e.day,
                        timeStart: timeStart,
                        timeEnd: timeEnd
                    }
                    let resultFind = res.data.courierAccounts.find(el => el.courierAccountId === e.courierAccountId)
                    this.courierInfo.courierAccounts.push({ ...resultFind, ...data })
                })
            }
            this.loadingTable = false
        }
    }
}
</script>
<style scoped>
    .btn-customer-dialog{
        text-align: right;
        padding: 30px 0;
    }
    .el-date-editor .el-range-separator {
        width: 10%;
    }
</style>
